export default __webpack_public_path__ + "static/pic01-803a84f8174400b47d45ae0ec3fa5271.jpg";